import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { HttpClient } from '@angular/common/http';
import { SignatureBoxFilter, SignatureDocument, SignatureDocumentUsers } from '../model/signatureDocumentUsers';

@Injectable({
  providedIn: 'root'
})
export class SignatureDocumentsService {

  baseUrl = `${environment.signatureUrl }/signatureDocuments`;
  constructor(private http: HttpClient) { }

  save(userInfo: SignatureDocument): Observable<any> {
    const url = `${this.baseUrl}/save`;

    return this.http.post(url, userInfo).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  findByIdDocumentAndIdType(idDocument: number, idType: number, currentVersion: number, active: boolean): Observable<any> {
    const url = `${this.baseUrl}/${idDocument}/${idType}/${currentVersion}/${active}`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  deleteById(id: number, reason: string): Observable<any> {
    const url = `${this.baseUrl}/delete/${id}`;

    const form = new FormData();
    form.append('reason', reason);

    return this.http.put(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  findAllBox(filter: SignatureBoxFilter): Observable<any> {
    const url = `${this.baseUrl}/box/all`;

    return this.http.post(url, filter).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  refuseToSign(id: number, idUserDoc: number, reason: string): Observable<any> {
      const url =  `${this.baseUrl}/${id}/${idUserDoc}/refuseToSign`;

      const form = new FormData();
      form.append('reason', reason);

      return this.http.put(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  saveDocumentUser(userInfo: SignatureDocumentUsers, token: string): Observable<any> {
    const url = `${this.baseUrl}/saveSignature`;

    return this.http.post(url, userInfo).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  existsFinishedByIdDocumentAndIdType(idSignature: number): Observable<any> {
    const url = `${this.baseUrl}/exists/${idSignature}`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
